import { Button, Input } from 'semantic-ui-react';
import { formInput } from 'src/components/helpers';
import { hasFormErrors } from 'src/containers/comunidad-network/form/networkFormUtils';

const NetworkFormLookupStep = ({ inputs, errorInputs, lookingUp, handleInputs, onContinue }) => {
  const continueFromEnter = (event) => {
    if (event.key !== 'Enter' || lookingUp) return;
    event.preventDefault();
    onContinue(event);
  };

  return (
    <section className="form-section">
      <h3 className="form-section__title">Verifica tu identidad</h3>
      <div className="form-section__body">
        <p className="header-subtitle" style={{ margin: '0 0 1rem', textAlign: 'left' }}>
          Ingresa tu cédula y celular para continuar con la inscripción.
        </p>
        <form
          className="lookup-form"
          onKeyDown={continueFromEnter}
          onSubmit={(e) => {
            e.preventDefault();
            if (lookingUp) return;
            onContinue(e);
          }}
        >
          <div className="field-grid">
            {formInput({
              Input,
              handler: handleInputs,
              label: 'Identificación',
              type: 'number',
              name: 'identification',
              value: inputs.identification || '',
              errorInputs,
            })}
            {formInput({
              Input,
              handler: handleInputs,
              label: 'Celular (WhatsApp)',
              type: 'number',
              name: 'phone',
              value: inputs.phone || '',
              errorInputs,
            })}
          </div>
          {hasFormErrors(errorInputs) && (
            <h4 className="form-error">Por favor verifica los campos obligatorios en rojo.</h4>
          )}
          <div className="actions__buttons">
            <Button type="submit" primary disabled={lookingUp} loading={lookingUp}>
              Continuar
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default NetworkFormLookupStep;
